<ix-modal-header
  [title]="helptext.import_title | translate"
  [loading]="isLoading"
></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form
      class="ix-form-container"
      [formGroup]="formGroup"
      (submit)="onSubmit()"
    >
      <ix-fieldset [title]="helptext.import_label | translate">
        <ix-select
          [formControlName]="pool.fcName"
          [label]="pool.label | translate"
          [tooltip]="pool.tooltip | translate"
          [options]="pool.options"
          [required]="true"
        ></ix-select>
      </ix-fieldset>
      <ix-form-actions>
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="import"
          [disabled]="formGroup.invalid || isLoading"
        >
          {{ 'Import' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
